import pino from "pino";
import { LoggerOptions } from "pino";

export enum LogLevel {
  ERROR = "error",
  WARN = "warn",
  INFO = "info",
  DEBUG = "debug",
}
export class Logger {
  private logger: pino.Logger;

  constructor(options: LoggerOptions) {
    this.logger = pino({
      level: options.level,
    });
  }

  public error(message: string | object, ...args: any[]): void {
    this.logger.error(message, ...args);
  }

  public warn(message: string | object, ...args: any[]): void {
    this.logger.warn(message, ...args);
  }

  public info(message: string | object, ...args: any[]): void {
    this.logger.info(message, ...args);
  }

  public debug(message: string | object, ...args: any[]): void {
    this.logger.debug(message, ...args);
  }
}
